export default __webpack_public_path__ + "1df10c939f9358204e8a03ca6dbf2e22.png";